import React, { useState, useCallback, useEffect } from "react";
import { Box, TextField, Typography, IconButton } from "@mui/material";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Handle } from "react-flow-renderer";
import { useNodeStorage } from "../../../stores/useNodeStorage";

const IxcBuscarClienteNode = React.memo(({ data, id }) => {
  const [cpfCnpjVariable, setCpfCnpjVariable] = useState(
    data?.cpfCnpjVariable || ""
  );
  const storageItems = useNodeStorage();

  const updateNodeData = useCallback(() => {
    data.cpfCnpjVariable = cpfCnpjVariable;
  }, [cpfCnpjVariable, data]);

  useEffect(() => {
    updateNodeData();
  }, [cpfCnpjVariable, updateNodeData]);

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        borderRadius: 2,
        boxShadow: 2,
        p: 2,
        width: 280,
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        border: "2px solid #1a237e",
      }}
    >
      <Handle
        type="target"
        position="left"
        id="ixcBuscarCliente-in"
        style={{
          left: -8,
          top: "50%",
          transform: "translateY(-50%)",
          background: "#1a237e",
          width: 12,
          height: 12,
        }}
      />

      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <PersonSearchIcon fontSize="small" sx={{ color: "#1a237e" }} />
          <Typography variant="subtitle2" fontWeight="bold" sx={{ color: "#1a237e" }}>
            IXC: Buscar Cliente
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 0.5 }}>
          <IconButton
            size="small"
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("duplicate");
            }}
          >
            <ContentCopyIcon fontSize="small" />
          </IconButton>
          <IconButton
            size="small"
            onClick={() => {
              storageItems.setNodesStorage(id);
              storageItems.setAct("delete");
            }}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>

      <TextField
        label="Variável com CPF/CNPJ"
        variant="outlined"
        size="small"
        value={cpfCnpjVariable}
        onChange={(e) => setCpfCnpjVariable(e.target.value)}
        fullWidth
        placeholder="${cpf_cnpj}"
        helperText="Ex: ${cpf_cnpj} ou nome da variável"
      />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, mt: 1 }}>
        <Typography variant="caption" color="textSecondary">
          Variáveis de saída: ixc_cliente_id, ixc_cliente_nome, ixc_cliente_cpf
        </Typography>
      </Box>

      <Handle
        type="source"
        position="right"
        id="success"
        style={{
          right: -8,
          top: "40%",
          background: "#4caf50",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "37%", color: "#4caf50", fontSize: "0.65rem" }}
      >
        Encontrado
      </Typography>

      <Handle
        type="source"
        position="right"
        id="not_found"
        style={{
          right: -8,
          top: "60%",
          background: "#ff9800",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "57%", color: "#ff9800", fontSize: "0.65rem" }}
      >
        Não encontrado
      </Typography>

      <Handle
        type="source"
        position="right"
        id="error"
        style={{
          right: -8,
          top: "80%",
          background: "#f44336",
          width: 12,
          height: 12,
        }}
      />
      <Typography
        variant="caption"
        sx={{ position: "absolute", right: 16, top: "77%", color: "#f44336", fontSize: "0.65rem" }}
      >
        Erro
      </Typography>
    </Box>
  );
});

export default IxcBuscarClienteNode;
